import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { legalSectionStyles } from '../styles';

const APP_VERSION = '0.2';

export const LegalLinks = () => {
  const { t } = useTranslation();

  return (
    <Box sx={legalSectionStyles.container}>
      <Typography variant="h6" sx={legalSectionStyles.title}>
        {t('ecommerce.support.legal.title', 'Información Legal')}
      </Typography>
      
      <Box sx={legalSectionStyles.linksContainer}>
        <Link 
          href="/terms" 
          sx={legalSectionStyles.link}
          underline="none"
        >
          {t('ecommerce.support.legal.terms', 'Términos y Condiciones')}
        </Link>
        <Link 
          href="/privacy" 
          sx={legalSectionStyles.link}
          underline="none"
        >
          {t('ecommerce.support.legal.privacy', 'Política de Privacidad')}
        </Link>
      </Box>
      
      <Typography sx={legalSectionStyles.versionText}>
        {t('ecommerce.support.legal.version', 'Versión de la aplicación')}: {APP_VERSION}
      </Typography>
    </Box>
  );
};

export default LegalLinks; 